import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

export const ATTACHMENT_CACHE_STORE = "attachmentCache";

export default {
  namespaced: true,

  state,

  actions,

  getters,

  mutations,
};
